const logArgs = (enableLog, ...args) => {
    if (enableLog) {
        console.log(...args);
    }
};

export default logArgs;
